export const languageLabelMap = {
  'zh-CN': '简体中文',
  'en-US': 'English',
  'ja-JP': '日本語',
  'th-TH': 'ภาษาไทย',
  // 新增语言（仅 merchant 页面使用，agent 页面零影响）
  'zh-TW': '繁體中文',
  'ko-KR': '한국어',
  'vi-VN': 'Tiếng Việt',
}

export const regionData = [
  {
    continent: 'agent_website.asia',
    countries: [
      {
        name: 'agent_website.HongKong',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Macau',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Japan',
        langs: [
          {
            label: languageLabelMap['ja'],
            value: 'ja-JP'
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Korea',
        langs: [
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Thailand',
        langs: [
          {
            label: languageLabelMap['th'],
            value: 'th-TH'
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Malaysia',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN',
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          },
          
        ]
      },
      {
        name: 'agent_website.Singapore',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN',
          },
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          },
          
        ]
      },
      {
        name: 'agent_website.Vietnam',
        langs: [
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      },
      
    ]
  },
  {
    continent: 'agent_website.other',
    countries: [
      {
        name: 'agent_website.other',
        langs: [
          {
            label: languageLabelMap['en'],
            value: 'en-US'
          }
        ]
      }
    ]
  }
]

export const languageOptions = [
  {
    label: languageLabelMap['zh-CN'],
    value: 'zh-CN'
  },
  {
    label: languageLabelMap['en-US'],
    value: 'en-US'
  },
  {
    label: languageLabelMap['ja-JP'],
    value: 'ja-JP'
  },
  {
    label: languageLabelMap['th-TH'],
    value: 'th-TH'
  }
]

// 商家官网专属全局语言选择器（按需求顺序：English → 简体中文 → 繁體中文 → 日本語 → ไทย → 한국어 → Tiếng Việt）
// 注意：原 languageOptions 保留不变，供 agent 页面继续使用，确保 agent 零改动。
export const merchantLanguageOptions = [
  {
    label: languageLabelMap['en-US'],
    value: 'en-US'
  },
  {
    label: languageLabelMap['zh-CN'],
    value: 'zh-CN'
  },
  {
    label: languageLabelMap['zh-TW'],
    value: 'zh-TW'
  },
  {
    label: languageLabelMap['ja-JP'],
    value: 'ja-JP'
  },
  {
    label: languageLabelMap['th-TH'],
    value: 'th-TH'
  },
  {
    label: languageLabelMap['ko-KR'],
    value: 'ko-KR'
  },
  {
    label: languageLabelMap['vi-VN'],
    value: 'vi-VN'
  }
]

// 商家官网专属地区语言配置：在 regionData 基础上为指定国家追加新语言。
//   HongKong / Macau 追加 繁體中文(zh-TW)
//   Korea 追加 한국어(ko-KR)
//   Vietnam 追加 Tiếng Việt(vi-VN)
// 原 regionData 保留不变，供 agent 页面继续使用。
export const merchantRegionData = [
  {
    continent: 'agent_website.asia',
    countries: [
      {
        name: 'agent_website.HongKong',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['zh-TW'],
            value: 'zh-TW'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Macau',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['zh-TW'],
            value: 'zh-TW'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Japan',
        langs: [
          {
            label: languageLabelMap['ja-JP'],
            value: 'ja-JP'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Korea',
        langs: [
          {
            label: languageLabelMap['ko-KR'],
            value: 'ko-KR'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Thailand',
        langs: [
          {
            label: languageLabelMap['th-TH'],
            value: 'th-TH'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
      {
        name: 'agent_website.Malaysia',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          },
        ]
      },
      {
        name: 'agent_website.Singapore',
        langs: [
          {
            label: languageLabelMap['zh-CN'],
            value: 'zh-CN'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          },
        ]
      },
      {
        name: 'agent_website.Vietnam',
        langs: [
          {
            label: languageLabelMap['vi-VN'],
            value: 'vi-VN'
          },
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      },
    ]
  },
  {
    continent: 'agent_website.other',
    countries: [
      {
        name: 'agent_website.other',
        langs: [
          {
            label: languageLabelMap['en-US'],
            value: 'en-US'
          }
        ]
      }
    ]
  }
]

// 合作代理商 Logo 配置
export const cooperationAgents = [
  { id: 1, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218219760419.jpg' },
  { id: 2, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218252177967.png' },
  { id: 3, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218261361901.png' },
  { id: 4, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218264997030.png' },
  // { id: 5, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218265613833.png' },
  { id: 6, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218265760094.png' },
  { id: 7, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/%E1%84%85%E1%85%A9%E1%84%80%E1%85%A9%E1%84%89%E1%85%A6%E1%84%85%E1%85%A9-20260605.png' },
  { id: 8, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219443056146.png' },
  { id: 9, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219449081571.jpg' },
  { id: 10, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219449882663.png' },
  { id: 11, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219743254274.png' },
  // { id: 12, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219745452144.jpg' },
  { id: 13, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219829737484.jpg' },
  { id: 14, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/220069471909.png' },
  { id: 15, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218261773616.png' },
  { id: 16, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/image%401x.png' },
  { id: 17, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/223448321435.jpg' },
  { id: 18, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/220026020561.png' },
  { id: 19, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/220020588214.jpg' },
  { id: 20, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219839477733.png' },
  { id: 21, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219829848376.png' },
  { id: 22, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219741509656.png' },
  { id: 23, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219696573467.jpg' },
  { id: 24, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/219695581448.jpg' },
  { id: 25, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218276043107.png' },
  { id: 26, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218272292783.png' },
  { id: 27, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218271924389.png' },
  { id: 28, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218271775247.png' },
  { id: 29, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/61aa2b4d0beaa04036d6a2dc14eb778920685.webp' },
  { id: 30, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218257358535.png' },
  { id: 31, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/4677a37f44b0585c5822900ebc217cfb65136.webp' },
  { id: 32, logo: 'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E4%BB%A3%E7%90%86%E5%95%86%E5%AE%98%E7%BD%91logo%E9%9B%86%E5%90%88/218252130020.png' },
]
